"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoginUrl = void 0;
const authUtils_1 = require("../authUtils");
const helpers_1 = require("../../../helpers");
const useAuthProces_1 = require("./useAuthProces");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const useLoginUrl = () => {
    const { setCodeVerifier } = (0, useAuthProces_1.useAuthProcess)();
    const loginTriggered = (0, react_1.useRef)(false);
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const getLoginUrl = () => {
        const { codeChallenger, codeVerifier } = (0, authUtils_1.generateExchangeCodes)();
        setCodeVerifier(codeVerifier);
        return (0, authUtils_1.getPKCELoginUrl)(codeChallenger, pathname);
    };
    const redirectToLogin = () => {
        if (loginTriggered.current)
            return;
        loginTriggered.current = true;
        const url = getLoginUrl();
        (0, helpers_1.redirectToUrl)(url);
    };
    return {
        getLoginUrl,
        redirectToLogin
    };
};
exports.useLoginUrl = useLoginUrl;
